import { ROUTES } from '../utils/enums';
import { sendRequest } from 'services/api';

const getRepairers = async () => {
    return sendRequest(ROUTES.GET_CONNECTED_REPAIRERS);
};

export default {
    getRepairers,
};
